import { DialogContent } from "@material-ui/core";
import React from "react";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import { createStyles, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() =>
  createStyles({
    content: {
      paddingLeft: 16
    },
    radioGroup: {
      display: "flex",
      justifyContent: "space-between"
    }
  })
);

interface TreeBlockTypeSelectorProps {
  outputType: string;
  outputTypes: string[];
  handleSelectType: (value: any) => void;
}

export const OutputTypeSelector = (props: TreeBlockTypeSelectorProps) => {
  const classes = useStyles();
  const { outputTypes, outputType } = props;

  const handleChange = (event: any) => {
    props.handleSelectType(event.target.value);
  };

  return (
    <>
      {outputTypes.length > 1 && (
        <DialogContent classes={{ root: classes.content }}>
          <FormControl component="fieldset">
            <RadioGroup
              aria-label="output-type"
              name="outputType"
              value={outputType}
              onChange={handleChange}
              row
              classes={{ row: classes.radioGroup }}
            >
              {outputTypes.map((type: string, index: number) => (
                <FormControlLabel
                  key={index}
                  value={type}
                  control={<Radio />}
                  label={type}
                />
              ))}
            </RadioGroup>
          </FormControl>
        </DialogContent>
      )}
    </>
  );
};
